import React from 'react';
import S from './FooterAddress.styles';
const FooterAddress = ({ address, title }) => {
    return (React.createElement(S.Container, null,
        title && React.createElement(S.Title, null, title),
        address && React.createElement(S.Address, { dangerouslySetInnerHTML: { __html: address } })));
};
export default FooterAddress;
